import { render, staticRenderFns } from "./TransferInStatus.vue?vue&type=template&id=6a0c88bd&scoped=true"
import script from "./TransferInStatus.vue?vue&type=script&lang=js"
export * from "./TransferInStatus.vue?vue&type=script&lang=js"
import style0 from "./TransferInStatus.vue?vue&type=style&index=0&id=6a0c88bd&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a0c88bd",
  null
  
)

export default component.exports